import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_THEME } from "../theme/theme";
import { apiCall } from "../utils/api";


function HeaderWithProfile() {
  const navigate = useNavigate();
  const [shadow, setShadow] = useState(false);
  const parsedData = JSON.parse(localStorage.getItem("credentials"));
  const [balance, setBalance] = useState(localStorage.getItem("balance") || "0.00");


  useEffect(() => {
    const handleScroll = () => {
      setShadow(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const result = apiCall(
          "balance",
          {},
          true
        )
        if (result.status) {
          setBalance(result.data.balance);
          localStorage.setItem("balance", result.data.balance)
        }
      } catch (error) {
        console.log(error.message)
      }
    }
    fetchBalance();
  }, [])


  return (
    <header
      className="sticky w-full top-0 left-0 right-0 h-14 flex items-center justify-between px-4 z-[950] max-w-full mx-auto transition-shadow duration-200"
      style={{
        background: APP_THEME.bgColor,
        boxShadow: shadow ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
      }}
    >
      <div className="flex items-center gap-3">
        {/* Settings Icon (User Initial) */}
        <div
          onClick={() => navigate("/profile")}
          className="w-10 h-10 rounded-full text-white flex items-center justify-center text-lg font-extrabold cursor-pointer transition-transform duration-200 active:scale-92"
          style={{
            background: `linear-gradient(135deg, ${APP_THEME.primaryColor}, ${APP_THEME.primaryDark})`,
            fontFamily: APP_THEME.fontFamily,
            border: "2px solid rgba(255, 255, 255, 0.2)",
            boxShadow: `0 4px 12px ${APP_THEME.primaryColor}40`,
          }}
        >
          {parsedData?.name.charAt(0).toUpperCase()}
        </div>

        {/* User Name and App Name */}
        <div className="flex flex-col">
          <span
            className="text-xs font-extrabold uppercase tracking-wide leading-none mb-0.5"
            style={{
              color: APP_THEME.primaryColor,
              fontFamily: APP_THEME.fontFamily,
              letterSpacing: "0.8px",
            }}
          >
            Hi, {parsedData?.name}
          </span>
          <span
            className="text-xs font-medium leading-tight max-w-[180px] whitespace-nowrap overflow-hidden truncate"
            style={{
              color: APP_THEME.textSecondary,
              fontFamily: APP_THEME.fontFamily,
            }}
          >
            Welcome Back!
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3.5">
        {/* Notification Bell */}
        <button
          onClick={() => navigate("/notification")}
          className="bg-transparent cursor-pointer relative w-[38px] h-[38px] rounded-full flex items-center justify-center transition-all duration-200"
          style={{
            border: `1.5px solid ${APP_THEME.borderColor}`,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = APP_THEME.surfaceColor)}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <span
            className="absolute top-2 right-2 w-2.5 h-2.5 rounded-full"
            style={{
              background: APP_THEME.errorColor,
              border: `2px solid ${APP_THEME.bgColor}`,
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            }}
          />
        </button>
      </div>

      <style>
        {`
          .active\\:scale-92:active {
            transform: scale(0.92);
          }
        `}
      </style>
    </header>
  );
}

export default HeaderWithProfile;